export const CrossIcon = ({
  size = 20,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <div
    style={{
      height: size,
      width: size,
    }}
    className={className}
  >
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17 7L7 17M7 7L17 17'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </div>
);
